// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* SetAutoComletePlaceList */0 :
        return {
                autoComletePlaceList: action._0,
                landmark: state.landmark,
                isPermissionDenied: state.isPermissionDenied
              };
    case /* SetLandmark */1 :
        return {
                autoComletePlaceList: state.autoComletePlaceList,
                landmark: action._0,
                isPermissionDenied: state.isPermissionDenied
              };
    case /* SetIsPermissionDenied */2 :
        return {
                autoComletePlaceList: state.autoComletePlaceList,
                landmark: state.landmark,
                isPermissionDenied: action._0
              };
    
  }
}

function getInitialState(param) {
  return {
          autoComletePlaceList: [],
          landmark: "",
          isPermissionDenied: false
        };
}

export {
  reducer ,
  getInitialState ,
}
/* No side effect */
